jQuery(document).ready(function ($) {

    let typingTimer;
    const doneTypingInterval = 500;

    if ($('#realm-nav-search__keyword').length > 0) {
        let searchKeyword = $('#realm-nav-search__keyword').val().trim();
    }
    const searchResultContainer = $('#realm-nav-search__result');
    const searchResult = $('#realm-nav-search__result-products');
    const searchBackdrop = $('#realm-nav-search__layer');
    const currentUrl = new URL(window.location.href);

    function showLoadingSpinner() {
        if ($('#product-list-overlay').length === 0) {
            $('#realm-nav-search__result-products').append(
                '<div id="product-list-overlay">' +
                '<div class="spinner"></div>' +
                '</div>'
            );
        }
        $('#product-list-overlay').show();
    }

    function hideLoadingSpinner() {
        $('#product-list-overlay').hide();
    }

    function scrollToTop() {
        $('html, body').animate({
            scrollTop: $(document.body).offset().top
        }, 300);
    }

    function clearSearchResults(clearInput = false) {
        searchResultContainer.addClass("is-hidden");
        searchResult.html('').addClass("is-hidden");
        searchBackdrop.css("display", "none");

        if (clearInput) {
            // Clear the search keyword
            $('#realm-nav-search__keyword').val('');
        }
    }

    function realm_nav_search(event, page = 1, pushState = true) {

        // Close when pressing Esc
        if (event && event.keyCode === 27) {
            clearSearchResults(true);
            return;
        }

        // Prevent behavior when pressing Enter
        if (event && event.keyCode === 13) {
            event.preventDefault();
            return;
        }

        // Update searchKeyword
        if (searchKeyword) {
            searchKeyword = $('#realm-nav-search__keyword').val().trim();
        }

        // Close when it's less than 3 letters
        if (searchKeyword.length < 3) {
            clearSearchResults(false);
            return;
        }

        clearTimeout(typingTimer);

        typingTimer = setTimeout(function () {
            $.ajax({
                url: realmNavSearch.ajaxurl,
                type: 'GET',
                data: {
                    action: 'realm_nav_search',
                    nonce: realmNavSearch.nonce,
                    s: searchKeyword,
                    paged: page,
                },
                dataType: 'json',
                beforeSend: function () {
                    showLoadingSpinner();
                },
                success: function (response) {
                    searchResultContainer.removeClass('is-hidden');
                    searchResult.removeClass('is-hidden');
                    searchBackdrop.css('display', 'block');
                    searchResult.html(response.results);

                    // Update currentUrl with search params
                    currentUrl.searchParams.set('s', searchKeyword);
                    if (page > 1) {
                        currentUrl.searchParams.set('paged', page);
                    } else {
                        currentUrl.searchParams.delete('paged');
                    }

                    // Update browser history
                    if (pushState) {
                        history.pushState(null, '', currentUrl.toString());
                    }

                },
                complete: function () {
                    scrollToTop();
                    hideLoadingSpinner();
                }
            });
        }, doneTypingInterval);
    }

    // Click to close search results if clicked outside
    $(document).on('click', function (event) {
        var target = $(event.target);
        if (!target.is('#realm-nav-search__keyword') && !target.closest(searchResultContainer).length) {
            clearSearchResults(true);
        }
    });

    // Input in the search field
    $('#realm-nav-search__keyword').on('input', function (event) {
        realm_nav_search(event);
    });

    // Enter key in the search field
    $('#realm-nav-search__keyword').on('keydown', function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    });

    // Pagination links in search results
    $(document).on('click', '#realm-nav-search__result .realm-nav-search__footer .pagination-link', function (event) {
        event.preventDefault();
        const page = $(this).attr('data-page');
        realm_nav_search(event, page, true);
    });

});